import { Pipe, PipeTransform } from '@angular/core';

import { colorMappingPigeon } from '../constants/constants';

@Pipe({ name: 'colorMappingPigeon' })
export class ColorMappingPigeonPipe implements PipeTransform {
  transform(parameter: string, value: number) {
    return colorMappingPigeon(parameter, value);
  }
}
